import {useQuery} from '@tanstack/react-query'
import {useNavigate, useParams} from 'react-router-dom'

import useRequestParams from 'src/feature/bite/hook/request'
import {transactionDetailSchemaResponse} from '../domain'
import {useTransactionDetail} from '../hook'
import {API} from 'src/feature/bite/domain'
import {getTimeZone} from 'src/feature/bite/helpers/date'

export function useGetTransaction() {
  const navigate = useNavigate()
  const {transactionId} = useParams()
  const {transactionDetailSet} = useTransactionDetail()
  const {auth, headers, signOut} = useRequestParams()

  const userID = auth()?.id

  const timeZoneOffSet = getTimeZone()

  return useQuery(
    ['transaction', transactionId],
    async () => {
      const filter = {
        filterList: [],
        orderList: [{type: 2, key: 'CreatedOn'}],
        paging: {currentPageNumber: 1, pageSize: 100},
        search: {value: '', keyList: []},
      }
      const response = await fetch(`${API}/Member/GetMemberTransactionDetails`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...filter,
          language: headers.Language,
          userID,
          transactionId,
          timeZoneOffSet,
        }),
      })

      if (response.status === 401) {
        signOut()
      }

      const data = await response.json()

      if (data.responseResult.result === false) {
        navigate('/error')
        return false
      }

      const safeParse = transactionDetailSchemaResponse.safeParse(data)

      if (!safeParse.success) {
        console.log(safeParse.error)
        throw new Error(safeParse.error.message)
      }

      const parse = transactionDetailSchemaResponse.parse(data)

      // if(!parse.response.transaction) {
      if (!parse.response || !parse.response.transactionId) {
        navigate('/error')
        return false
      }

      // transactionDetailSet(parse.response.transaction)
      transactionDetailSet(parse.response)

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: () => {},
      onError: (error) => {
        console.log(error)
      },
    }
  )
}
